import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownItemProps,
  DropdownTrigger,
  IconButton,
  RiDeleteBinLine,
  RiMore2Fill,
  Stack,
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from 'component-library';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Plot } from '@/api/rest/resources/types/plot';
import { usePlot } from '@/pages/shared/hooks/usePlot';
import { paths } from '@/routing';
import { buildPath } from '@/utils/buildPath';

import { DeletePlotWithConfirmation } from '../../../components/plot-list/DeletePlotWithConfirmation';

export const PlotActionsDropdown = () => {
  const { t } = useTranslation();

  const [plotForDeletion, setPlotForDeletion] = useState<Plot | null>(null);

  const plot = usePlot().data;

  const editDeleteDisabledHint = t('shared.projects.plot.tooltips.disabledEditOrDeletePlot');

  const projectId = (plot.project ?? plot.project_id) as string;

  return (
    <>
      <Stack spacing={6} direction='row'>
        <Dropdown>
          <DropdownTrigger asChild>
            <IconButton className='border border-primary-100 text-primary-100' data-testid='nav-overview-more-button'>
              <RiMore2Fill size={24} />
            </IconButton>
          </DropdownTrigger>
          <DropdownContent align='end'>
            {/* TODO: Removed until FE capability to edit plots is fixed */}
            {/* <MenuDropdownItemLink
              disabled={false}
              disabledHint={editDeleteDisabledHint}
              to={buildPath(paths.landSteward.editPlot, { pathParams: { plotId: plot.id, projectId } })}
              state={{
                previousPath: pathname,
              }}
              leftAdornment={<RiEditLine />}
            >
                      {t('shared.plots.overflowMenu.editPlotData')}
                  </MenuDropdownItemLink> */}
            <MenuDropdownItem
              disabled={false}
              disabledHint={editDeleteDisabledHint}
              onClick={() => setPlotForDeletion(plot)}
              leftAdornment={<RiDeleteBinLine />}
            >
              {t('shared.plots.overflowMenu.deletePlot')}
            </MenuDropdownItem>
          </DropdownContent>
        </Dropdown>
      </Stack>
      <DeletePlotWithConfirmation
        plot={plotForDeletion}
        onClose={() => setPlotForDeletion(null)}
        onSuccess={() => {
          /**
           * using href instead of navigate to ensure a reload is triggered automatically
           * using navigate + invalidating queries creates a race condition
           */
          window.location.href = buildPath(paths.landSteward.projectPlots, { pathParams: { projectId } });
        }}
      />
    </>
  );
};

type MenuDropdownItemProps = DropdownItemProps & {
  disabledHint: string;
};

const MenuDropdownItem: FC<MenuDropdownItemProps> = ({ children, disabledHint, ...delegated }) => {
  if (!delegated.disabled) {
    return <DropdownItem {...delegated}>{children}</DropdownItem>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <DropdownItem {...delegated}>{children}</DropdownItem>
      </TooltipTrigger>
      <TooltipContent sideOffset={5} side='left'>
        {disabledHint}
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
